module.exports = function (Component) { Component.options.__i18n = '{"en":{"content":"Your name","button_join":"Join"},"de":{"content":"Ihr Name","button_join":"Beitreten"}}' }


//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/JoinPrompt.vue
// module id = 143
// module chunks = 1